import { Link } from "react-router-dom";
import WelcomeAdmin from "../adminPages/welcomeAdmin";
import { useUser } from "../userContext";
import "./adminAccessNav.css";
import { useEffect, useState } from "react";

const AdminAccessNav = () => {
  const { currentUser, setCurrentUser } = useUser();

  return currentUser ? (
    <div className="admin-link">
      <WelcomeAdmin currentUser={currentUser} />
    </div>
  ) : null;
};

export default AdminAccessNav;
